module.exports = __webpack_public_path__ + "static/media/garyBorn.f1b89408.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/garyBorn.jpg
// module id = 1674
// module chunks = 1